<label class="inner-label" [translate]="labelText"></label>
